import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsCardComponent } from '../../shared/components/cards/news-card.component';
import { NewsLinkApiService } from './services/api/news-link.api.service';
import { NewsLinkModel } from './models/news-link.model';

@Component({
  selector: 'app-news',
  imports: [NewsCardComponent, CommonModule],
  templateUrl: './news.component.html',
  styleUrl: './news.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class NewsComponent implements OnInit {
  // Mensagens de erro
  private readonly ERR_NO_NEWS =
    'Não há notícias disponíveis no momento. Em breve, novas informações serão divulgadas.';
  private readonly ERR_NETWORK_NEWS =
    'Não foi possível retornar as notícias devido a um problema de comunicação com o servidor. Por favor, acesse o Sismet Web novamente mais tarde.';
  private readonly ERR_SERVER_NEWS =
    'Não foi possível retornar as notícias devido a um problema no servidor. Por favor, acesse o Sismet Web novamente mais tarde.';

  newsLinks: NewsLinkModel[] = [];
  isLoading = true;
  errorMessage = '';
  isServerError = false;

  constructor(private readonly newsLinkService: NewsLinkApiService) {}

  ngOnInit(): void {
    this.loadNews();
  }

  /**
   * Carrega notícias da API
   */
  private loadNews(): void {
    this.isLoading = true;
    this.errorMessage = '';
    this.isServerError = false;

    this.newsLinkService.getActiveLinks().subscribe({
      next: (data) => {
        this.newsLinks = data;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;

        // Tratamento específico por tipo de erro
        if (error.status === 404) {
          // 404: API funcionando, mas sem notícias cadastradas
          this.errorMessage = this.ERR_NO_NEWS;
          this.newsLinks = [];
          this.isServerError = false;
        } else if (error.status === 0) {
          // Erro de rede/servidor offline
          this.errorMessage = this.ERR_NETWORK_NEWS;
          this.newsLinks = [];
          this.isServerError = true;
        } else {
          // Outros erros
          this.errorMessage = this.ERR_SERVER_NEWS;
          this.newsLinks = [];
          this.isServerError = true;
        }
      },
    });
  }

  /**
   * Retorna o ícone apropriado baseado no tipo de link
   */
  getIconForType(type: string): string {
    const iconMap: { [key: string]: string } = {
      EXTERNAL_LINK: 'fa-newspaper',
      IMAGE: 'fa-image',
      VIDEO: 'fa-video',
      DOCUMENT: 'fa-file-alt',
    };

    return iconMap[type] || 'fa-newspaper';
  }

  /**
   * Formata a data de criação para exibição em formato brasileiro
   */
  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  /**
   * Retorna a descrição da notícia, com fallback e limite de caracteres
   */
  getDescription(description: string | null): string {
    const defaultDescription =
      'Clique no botão abaixo para acessar o conteúdo completo desta notícia.';
    const text = description || defaultDescription;
    const maxLength = 150;

    if (text.length <= maxLength) {
      return text;
    }

    return text.substring(0, maxLength).trim() + '...';
  }
}
